<template>
  <modal v-if="isModalOpen" @close="closeModal" class="remove-product-modal">
		<div slot="header" class="display-1 mobile-headline-6">Reset experiment</div>
		<div class="content body-1">
			<div>
				<p>
          Your experiment will be reset to the default set-up.
        </p>
			</div>
		</div>
		<div class="footer" slot="footer">
			<md-button class="md-primary md-button-large cancel-button" @click.stop="closeModal">
				<span>Cancel</span>
			</md-button>
        <md-button class="md-primary md-raised md-button-large reset-button" @click="$emit('resetWorkflow')">
          <base-icon icon-name="reset" iconSize="18px" />
          reset
        </md-button>
		</div>
	</modal>
</template>

<script>
export default {
	name: 'ResetWorkflowModal',
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {

  .cancel-button {
    margin-right: 16px !important;
  }

  .reset-button {
    i {
      position: relative;
      bottom: 2px;
    }
  }
}
</style>